import type { IconData } from '@stacksjs/iconify-core'

export const cz4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v240H0z\"/><path fill=\"#d7141a\" d=\"M0 240h640v240H0z\"/><path fill=\"#11457e\" d=\"M360 240L0 0v480z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cz4x3
